<template>
  <div>
    <div v-if="!isRightUser">
      Please contact SCC Admin, to confirm you permissions. The user Id does not match.
    </div>
    <div v-else>
      <div v-if="addNewUser">
        <email-verification
          ref="refEmailVerification"
          :page-title="title"
          :erorr-message="emailSubmitErorrMessage"
          :is-submitted="isEmailSubmitted"
          @submit="onSubmitEmail"
        />
      </div>
      <div v-else>
        <div id="userProfileInfo">
          <profile-info-edit
            ref="refCompanyInfo"
            :user-profile-id="userId"
            :user-profiles-data="currentUser"
          />
        </div>
        <div id="contactInfo" style="display: none">
          <contact-info-edit
            ref="refContactInfo"
            :user-profile-id="userId"
            :user-profiles-data="currentUser"
          />
        </div>
        <div id="securityQuestions" style="display: none">
          <security-questions-edit
            ref="refSecurityQuestions"
            :user-profile-id="userId"
            :user-profiles-data="currentUser"
          />
        </div>
        <div id="userName" style="display: none">
          <div v-show="isUserProfile">
            <update-email
              ref="refUpdateEmail"
              :user-profile-id="userId"
              :user-profiles-data="currentUser"
            />
          </div>
        </div>
        <div id="password" style="display: none">
          <div v-show="!isUserProfile">
            <web-login-info
              ref="refwebLoginInfo"
              :user-profile-id="userId"
              :user-profiles-data="currentUser"
              :enableForcePasswordChange="true"
              :handleSubmit="onSubmitPassword"
              @enable-submit="(val) => ( this.isSubmitDisabled = !val)"
            />
          </div>
          <div class="align-center-bottom">
            <ejs-button
              type="button"
              v-on:click.native="onSubmitPassword"
              cssClass="e-info margin-button"
              :disabled="isSubmitDisabled"
              >Submit</ejs-button
            >
          </div>
        </div>
        <div id="notes" style="display: none">
          <div>
            <div>
              <h4 class="title-color">Notes</h4>
            </div>
            <div class="e-card-separator"></div>
            <div>
              <user-notes-list :user-profile-id="userId">
              </user-notes-list>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isNewUser">
        <div class="back-header" v-if="isLogedUserAdmin && !isNewUserProcess">
          <ejs-button v-on:click.native="onCancelButtonClick" cssClass="e-danger margin-button"
            >Back to Customer Details List</ejs-button
          >
        </div>
        <div tabindex="0" id="basic">
          <div>
            <ejs-tab
              id="collapsible_tab"
              class="e-background"
              ref="refTabInstance"
              :created="tabCreated"
              :selected="tabSelected"
              :selecting="tabSelect"
            >
              <e-tabitems>
                <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
                <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
                <e-tabitem :header="headerText2" :content="content2"></e-tabitem>
                <e-tabitem :header="headerText3" :content="content3"></e-tabitem>
                <e-tabitem :header="headerText4" :content="content4"></e-tabitem>
                <e-tabitem :header="headerText5" :content="content5"></e-tabitem>
              </e-tabitems>
            </ejs-tab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import { mapGetters } from "vuex";
import { FETCH_USER_BY_ID, CONFIRM_USER_EMAIL } from "../../auth/store";
import ProfileInfoEdit from "../components/profile-info-edit.vue";
import ContactInfoEdit from "../components/contact-info-edit.vue";
import SecurityQuestionsEdit from "../components/security-questions-edit.vue";
import UpdateEmail from "../components/update-email.vue";
import UserNotesList from "../components/user-notes.vue";

import EmailVerification from "../../auth/components/email-verification.vue";
import WebLoginInfo from "../components/web-login-info.vue";

Vue.use(ButtonPlugin);
Vue.use(TextBoxPlugin);
Vue.use(TabPlugin);

export default {
  name: "ManageCustomer",
  components: {
    ProfileInfoEdit,
    SecurityQuestionsEdit,
    ContactInfoEdit,
    UpdateEmail,
    UserNotesList,

    EmailVerification,
    WebLoginInfo,
  },
  created() {
    this.userId = this.$route.params.id;
    this.paramId = this.$route.params.id;
    this.getUserById().then(() => {
      this.currentUser = this.$store.getters.userById;
    });
  },
  data() {
    return {
      title: "Add Web User",
      isEmailSubmitted: false,
      emailSubmitErorrMessage: null,
      userId: null,
      currentUser: null,
      headerText0: { text: "Personal Details" },
      headerText1: { text: "Contact Information" },
      headerText2: { text: "Security Question" },
      headerText3: { text: "Update Email" },
      headerText4: { text: "Password" },
      headerText5: { text: "Notes" },
      content0: "#userProfileInfo",
      content1: "#contactInfo",
      content2: "#securityQuestions",
      content3: "#userName",
      content4: "#password",
      content5: "#notes",
      userProfileData: null,
      userNewEmail: "",
      erorrMessageOnSubmit: null,
      isUserProfile: true,
      phoneNumberValid: [],
      paramId: null,
      isSubmitDisabled: true,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
    }),
    isLogedUserAdmin() {
      return this.isLogedUserInRole("admin") || this.isLogedUserInRole("superadmin");
    },
    addNewUser() {
      return this.userId === "null" && (this.isLogedUserAdmin || this.isLogedUserSuperAdmin);
    },
    isNewUser() {
      return this.userId === "null";
    },
    isNewUserProcess() {
      return this.paramId === "null";
    },
    isRightUser() {
      return this.isLogedUserAdmin || this.userId === this.loggedUser?.id;
    },
  },
  methods: {
    enableSubmit(val) {
      // console.log(0, val);
      this.isSubmitDisabled = !val;
    },
    showNotification(inValidFields, content) {
      const parent = this.$parent;
      const notificationObj = {
        content,
        timeOut: 5000,
      };
      if (inValidFields.length === 0) {
        notificationObj.cssClass = "e-toast-success";
        notificationObj.title = "Success!";
      } else {
        notificationObj.cssClass = "e-toast-danger";
        notificationObj.title = "Error!";
      }
      parent.notificationToasts.push(notificationObj);
      parent.$refs.notifierRef.show();
    },
    isLogedUserInRole(roleName) {
      let roleIndex = -1;
      const logedUser = this.loggedUser;
      if (logedUser && logedUser.roles) {
        roleIndex = logedUser.roles.findIndex((r) => r.roleName.toLowerCase() === roleName);
      }
      return roleIndex >= 0;
    },
    async getUserById() {
      try {
        if (this.userId !== null && this.userId !== "null") {
          const { userId } = this;
          await this.$store.dispatch(FETCH_USER_BY_ID, { userId });
        } else {
          this.currentUser = null;
        }
      } catch (err) {
        console.error("user accounts err", err);
        if (err.message === "Network Error") {
          this.$router.push({ name: "NotFound" });
        } else {
          this.$router.push({ name: "UnAuthorized" });
        }
      }
    },
    onCancelButtonClick() {
      this.$router.push("/users");
    },
    tabCreated() {
      // After tab created first tab content and active line are
      // hidden by adding custom class to make it collapse state
      // if admin is adding user then "isUserProfile = false" no needs to desplay Update Email tab.
      if (this.isUserProfile) {
        this.$refs.refTabInstance.ej2Instances.items[3].visible = true;
        this.$refs.refTabInstance.ej2Instances.items[4].visible = false;
      } else {
        this.$refs.refTabInstance.ej2Instances.items[3].visible = false;
        this.$refs.refTabInstance.ej2Instances.items[4].visible = true;
      }
      this.$refs.refTabInstance.ej2Instances.items[5].visible = this?.loggedUser?.isSCCUser;
    },
    tabSelect(e) {
      let isValid = true;
      // eslint-disable-next-line default-case
      switch (e.selectedIndex) {
        case 0:
          // hide notificaiton message from novigation
          isValid = this.$refs.refCompanyInfo.onSubmitUserProfileClick(true);
          break;
        case 1:
          // hide notificaiton message from novigation
          isValid = this.$refs.refContactInfo.onSubmitContactClick(true);
          break;
        case 2:
          // hide notificaiton message from novigation
          // eslint-disable-next-line max-len
          isValid = this.isLogedUserAdmin ? true : this.$refs.refSecurityQuestions.onSubmitSecurityQuestionClick(true);
          break;
        case 3:
          isValid = true;
          if (this.$refs.refUpdateEmail.newUserName) {
            isValid = this.$refs.refUpdateEmail.validateForm();
          }
          break;
        case 4:
          isValid = this.validateForm();
          break;
      }
      // console.log(22, isValid);
      if (!isValid) {
        e.cancel = true;
      }
    },
    tabSelected(e) {
      // If next tab item selected custom class is removed from content and active line element
      const cnttrgs = document.querySelectorAll("#collapsible_tab.e-tab > .e-content > .e-item");
      for (let i = 0; i < cnttrgs.length; i += 1) {
        cnttrgs[i].classList.remove("collapse");
      }
      if (this.actLine !== undefined) {
        this.actLine.classList.remove("collapse");
      }
      this.trgIndex = e.selectedIndex;
      // Custom click event binding for each tab item to make collapse/expand
      e.selectedItem.addEventListener("click", () => {
        this.updateCollapseClass(this.trgIndex);
      });
    },
    updateCollapseClass(index) {
      // Custom classes are added/removed from tab content and active line
      // element, when the same tab item again clicked
      const cntEle = document.getElementById(`e-content_${index}`);
      if (cntEle) {
        if (cntEle.classList.contains("collapse")) {
          cntEle.classList.remove("collapse");
          this.actLine.classList.remove("collapse");
        } else {
          cntEle.classList.add("collapse");
          this.actLine.classList.add("collapse");
        }
      }
    },
    async onSubmitEmail(email) {
      const refEmailVerify = this.$refs.refEmailVerification;
      const userName = email;
      const rootURL = window.location.host;
      if (refEmailVerify.isEmailValid) {
        try {
          await this.$store.dispatch(CONFIRM_USER_EMAIL, {
            userName,
            rootURL,
            confirmType: "admin-registration",
          });
          if (this.$store.getters.userDetails.status === 200) {
            this.currentUser = this.$store.getters.userDetails.data;
            if (this.$store.getters.userDetails.data.userProfile === null) {
              this.isUserProfile = false;
            }
            this.userId = this.currentUser.userId;
            this.$parent.notificationToasts.push({
              title: "Success!",
              content: "Username verified successfully.",
              cssClass: "e-toast-success",
              timeOut: 5000,
            });
            // this.username = userName;
            this.isEmailSubmitted = true;
            this.emailSubmitErorrMessage = null;
            // this.isHideCreateAccount = true;
          } else if (this.$store.getters.userDetails) {
            switch (this.$store.getters.userDetails) {
              case 403:
                this.erorrMessageOnSubmit = "Account exist with given email id.";
                break;
              case 409:
                this.erorrMessageOnSubmit = "Account exist with given email id.";
                break;
              case 423:
                this.erorrMessageOnSubmit = "Given email id is locked.";
                break;
              case 404:
                this.$router.push("/NotFound");
                break;
              default:
                this.erorrMessageOnSubmit = "Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099 ";
            }
            if (this.erorrMessageOnSubmit) {
              this.$parent.notificationToasts.push({
                title: "Error!",
                content: this.erorrMessageOnSubmit,
                cssClass: "e-toast-danger",
                timeOut: 5000,
              });
            }
            this.emailSubmitErorrMessage = this.erorrMessageOnSubmit;
          }
        } catch (err) {
          this.erorrMessageOnSubmit = "Oops, Something went wrong. We are working on getting this fixed as soon as we can. You may be able to try again shortly. If you continue to experience this issue, you can contact ASCA Tanks at ascatanks@safetycodes.ab.ca or by calling 1-888-413-0099 ";
          if (this.erorrMessageOnSubmit) {
            this.$parent.notificationToasts.push({
              title: "Error!",
              content: this.erorrMessageOnSubmit,
              cssClass: "e-toast-danger",
              timeOut: 5000,
            });
          }
          this.emailSubmitErorrMessage = this.erorrMessageOnSubmit;
        }
      } else {
        refEmailVerify.validateEmail();
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: "Please provide valid email id.",
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    validateForm() {
      const loginInfo = this.$refs.refwebLoginInfo;
      if (!(loginInfo.isPasswordValid
        && loginInfo.isConfirmPassword
        && loginInfo.showConfirmPasswordMatch)) {
        loginInfo.validatePassword();
        this.notifySuccessMessage = "";
        this.notifyErrorMessage = "Please enter value in required fields.";
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: this.notifyErrorMessage,
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }

        return false;
      }

      return true;
    },
    async onSubmitPassword() {
      let isValid = true;
      const loginInfo = this.$refs.refwebLoginInfo;
      if (
        loginInfo.isPasswordValid
        && loginInfo.isConfirmPassword
        && loginInfo.showConfirmPasswordMatch
      ) {
        await loginInfo.register();
        this.notifyErrorMessage = "";
        this.notifySuccessMessage = "Password has successfully added.";
        this.$parent.notificationToasts.push({
          title: "Success!",
          content: this.notifySuccessMessage,
          cssClass: "e-toast-success",
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }
        if (this.isNewUserProcess && this.isLogedUserAdmin) {
          this.$router.push("/users");
        }
      } else {
        loginInfo.validatePassword();
        this.notifySuccessMessage = "";
        this.notifyErrorMessage = "Please enter value in required fields.";
        this.$parent.notificationToasts.push({
          title: "Error!",
          content: this.notifyErrorMessage,
          cssClass: "e-toast-danger",
          timeOut: 5000,
        });
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }

        isValid = false;
      }

      return isValid;
    },
  },
};
</script>
<style>
.container {
  padding: 20px 2% 0px 20px;
}
.back-header {
  font-size: small;
  padding: 1px 1px 5px 1px;
  text-align: right;
  width: 100%;
}
.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 2px 2px;
  width: 90%;
}

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
</style>
